<template>
  <div>
    <b-modal ref="createPriceModal"
             :title="title" :no-close-on-backdrop="true">
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.price_list.price_list_number')}}</label>
        </b-col>
        <b-col cols="4">
          <input class="form-control" v-model="priceData.price_nr" tabindex="1"
                 :class="{ required: (!priceData.price_nr) }"
                 :disabled="shouldDisableInput"
                 placeholder="">
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.price_per_uom')}}</label>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="priceData.price_per_unit" :tabindex="12"
                 placeholder=""
                 :disabled="shouldDisableInput"
                 :class="{ required: (!priceData.price_per_unit) }"
                 v-digits-after-decimal="{numberOfDigits: 2}">
        </b-col>
        <b-col cols="2">
          <input class="form-control" :value="(priceList.currency && priceList.currency.code) || 'EUR'" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.wood')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="priceData.wood" :max-height="200" :tabindex="2"
                       placeholder="" label="name" track-by="id"
                       :options="wood" :multiple="false"
                       @select="selectHumidity"
                       :show-labels="false"
                       :disabled="shouldDisableInput"
                       :class="{ required: (!priceData.wood || priceData.wood.length === 0) }"
                       :taggable="true"></multiselect>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.supplier')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="priceData.shippers" :max-height="200" :tabindex="13"
                       placeholder="" label="name" track-by="id"
                       :options="suppliers" :disabled="shouldDisableInput"
                       :close-on-select="false"
                       :show-labels="false" :multiple="true"
                       :taggable="true"></multiselect>
        </b-col>
      </b-row>
      <b-row class="mt-0 sizes-label">
        <b-col offset="2" cols="4">
          <b-row>
            <b-col cols="4">{{$t('labels.common.nominal')}}</b-col>
            <b-col class="text-center">{{$t('labels.common.stock_sizes')}}</b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-0">
        <b-col cols="2">
          <label>{{$t('labels.common.thickness')}}</label>
        </b-col>
        <b-col cols="4">
          <b-row>
            <b-col cols="4">
              <input class="form-control" v-model="priceData.thickness_nominal" tabindex="3"
                     :class="{ required: (!priceData.thickness_nominal && priceData.thickness_nominal !== 0) }"
                     :disabled="shouldDisableInput"
                     placeholder="" v-replace-with-positive>
            </b-col>
            <b-col class="sizes-from-to">
              <input class="form-control" v-model="priceData.thickness_stock_from" tabindex="3"
                     :class="{ required: (!priceData.thickness_stock_from && priceData.thickness_stock_from !== 0) }"
                     :disabled="shouldDisableInput"
                     placeholder="" v-replace-with-positive>
              -
              <input class="form-control" v-model="priceData.thickness_stock_to" tabindex="4"
                     :class="{ required: (!priceData.thickness_stock_to && priceData.thickness_stock_to !== 0) }"
                     placeholder="" :disabled="shouldDisableInput" v-replace-with-positive>
            </b-col>

          </b-row>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.date_start')}}</label>
        </b-col>
        <b-col cols="4">
          <datepicker v-model="priceData.date_start" lang="en" :tabindex="14"
                      placeholder=""
                      :class="{ required: !priceData.date_start }"
                      :disabled="shouldDisableInput" :first-day-of-week="1"
          ></datepicker>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.width')}}</label>
        </b-col>
        <b-col cols="4">
          <b-row>
            <b-col cols="4">
              <input class="form-control" v-model="priceData.width_nominal" tabindex="5"
                     placeholder="" :disabled="shouldDisableInput"
                     :class="{ required: (!priceData.width_nominal && priceData.width_nominal !== 0) }"
                     v-replace-with-positive
              >
            </b-col>
            <b-col class="sizes-from-to">
              <input class="form-control" v-model="priceData.width_stock_from" tabindex="5"
                     placeholder="" :disabled="shouldDisableInput"
                     :class="{ required: (!priceData.width_stock_from && priceData.width_stock_from !== 0) }"
                     v-replace-with-positive
              >
              -
              <input class="form-control" v-model="priceData.width_stock_to" tabindex="6"
                     :disabled="shouldDisableInput"
                     :class="{ required: (!priceData.width_stock_to && priceData.width_stock_to !== 0) }"
                     placeholder="" v-replace-with-positive>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.date_end')}}</label>
        </b-col>
        <b-col cols="4">
          <datepicker v-model="priceData.date_end" lang="en" :tabindex="14"
                      placeholder=""
                      :disabled="shouldDisableInput" :first-day-of-week="1"
          ></datepicker>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.length')}}</label>
        </b-col>
        <b-col cols="4">
          <b-row>
            <b-col cols="4">
              <input class="form-control" v-model="priceData.length_nominal" tabindex="7"
                     placeholder="" :disabled="shouldDisableInput"
                     :class="{ required: (!priceData.length_nominal && priceData.length_nominal !== 0) }"
                     v-replace-with-positive>
            </b-col>
            <b-col class="sizes-from-to">
              <input class="form-control" v-model="priceData.length_stock_from" tabindex="7"
                     placeholder="" :disabled="shouldDisableInput"
                     :class="{ required: (!priceData.length_stock_from && priceData.length_stock_from !== 0) }"
                     v-replace-with-positive>
              -
              <input class="form-control" v-model="priceData.length_stock_to" tabindex="8"
                     :class="{ required: (!priceData.length_stock_to && priceData.length_stock_to !== 0) }"
                     placeholder="" :disabled="shouldDisableInput"
                     v-replace-with-positive>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.transport')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect ref="transportSelect" v-model="priceData.delivery_method" :max-height="200" :tabindex="15"
                       placeholder="" label="name" track-by="id"
                       :options="delivery_methods" :disabled="shouldDisableInput"
                       :multiple="false" taggable
                       >
            <template slot="tag" slot-scope="props">
              <multiselect-tag-slot :props="props" props-label="name"></multiselect-tag-slot>
            </template>
          </multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.quality')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="priceData.qualities" :max-height="200" :tabindex="9"
                       placeholder="" label="name" track-by="id"
                       :options="qualities_list" multiple
                       :class="{ required: (!priceData.qualities || priceData.qualities.length === 0) }"
                       :show-labels="false" :disabled="shouldDisableInput"
                       :close-on-select="false"
                       :taggable="true"></multiselect>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.delivery_term')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect ref="incotermsSelect" v-model="priceData.incoterms" :max-height="200" :tabindex="16"
                       placeholder="" label="code" track-by="id"
                       :options="incoterms" :disabled="shouldDisableInput" :options-height="120"
                       :close-on-select="false"
                       :show-labels="false" :multiple="true"
                       :taggable="true">
            <template slot="tag" slot-scope="props">
              <multiselect-tag-slot :props="props" :props-label="'code'"></multiselect-tag-slot>
            </template>
          </multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.profiles')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="priceData.profiles" :max-height="200" :tabindex="10"
                       placeholder=""
                       :options="profiles" multiple
                       label="name" track-by="id"
                       :close-on-select="false"
                       :show-labels="false" :disabled="shouldDisableInput"
                       taggable />
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.payment_terms')}}</label>
        </b-col>
        <b-col cols="4">
          <input class="form-control" v-model="priceData.payment_term" tabindex="17"
                 :disabled="shouldDisableInput"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.humidity')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="priceData.humidities" :max-height="200" :tabindex="10"
                       placeholder=""
                       :options="humidity_list" multiple
                       :class="{ required: (!priceData.humidities) }"
                       :close-on-select="false"
                       :show-labels="false" :disabled="shouldDisableInput"
                       :taggable="true"></multiselect>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.notes')}}</label>
        </b-col>
        <b-col cols="4">
          <b-form-textarea v-model="priceData.notes" placeholder="" :disabled="shouldDisableInput" :tabindex="18">
          </b-form-textarea>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn size="sm" variant="success" @click="saveLot('save')" :disabled="shouldDisableInput">
          {{$t('buttons.common.save')}}
        </b-btn>
        <b-btn size="sm" variant="success" @click="saveLot('add_another')" :disabled="shouldDisableInput">
          {{$t('buttons.common.save_add_more')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import multiselectTagSlot from '@/components/common/multiselectTagSlot';
  import {
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { DATE_FORMAT } from '@/constants';

  export default {
    props: ['price', 'selectedPrice', 'priceList'],
    components: {
      Multiselect,
      Datepicker,
      multiselectTagSlot
    },
    data() {
      return {
        humidity: [],
        priceData: {
          price_nr: '',
          wood: '',
          thickness_nominal: '',
          thickness_stock_from: '',
          thickness_stock_to: '',
          width_nominal: '',
          width_stock_from: '',
          width_stock_to: '',
          length_nominal: '',
          length_stock_from: '',
          length_stock_to: '',
          qualities: [],
          profiles: [],
          humidities: [],
          price_per_unit: '',
          shippers: [],
          date_start: '',
          date_end: '',
          delivery_method: '',
          incoterms: [],
          payment_term: '',
          notes: '',
          price_list: '',
          status: "active"
        },
        priceDataInitial: {}
      }
    },
    methods: {
      async loadSettings() {
        this.$store.dispatch('partners/getSuppliers');
        this.$store.dispatch('woodware/loadHumidityList');
        await this.$store.cache.dispatch('woodware/getWood');
        await this.$store.cache.dispatch('generic/loadIncoterms');
        await this.$store.cache.dispatch('woodware/getDeliveryMethods');
        await this.$store.dispatch('woodware/getQualitiesList');
        this.setDefaults();
      },
      setDefaults() {
        //set Wood Pusis
        // this.priceData.wood = this.wood.find(e => e.id === 2);
        //set incoterms FCA
        this.priceData.incoterms = this.incoterms.filter(e => e.id === 4);
        // set delivery method truck
        this.priceData.delivery_method = this.delivery_methods.find(e => e.id === 2);
        //set quality 1-3
        this.priceData.quality = this.qualities_list.find(e => e.id === 19);
        this.priceDataInitial = {...this.priceData};
      },
      handleSaveEvent (event) {
        if (event === 'add_another') {
          this.priceData = {
            ...this.priceData,
            price_nr: '',
            price_per_unit: '',
            shippers: [],
            notes: ''
          }
          this.$set(this.priceDataInitial, 'isNewPrice', true)
          // this.setDefaults();
        } else {
          this.$refs['createPriceModal'].hide()
        }
      },
      saveLot(event) {
        const saveData = {
          ...this.priceData,
          price_list: this.isNewPrice ? this.price : this.priceData.price_list,
          wood: this.priceData.wood ? this.priceData.wood.id : '',
          incoterms: this.priceData.incoterms ? getArrayByProperty(this.priceData.incoterms, 'id') : [],
          date_start: this.priceData.date_start ? moment(this.priceData.date_start).format(DATE_FORMAT) : null,
          date_end: this.priceData.date_end ? moment(this.priceData.date_end).format(DATE_FORMAT) : null,
          qualities: this.priceData.qualities ? getArrayByProperty(this.priceData.qualities, 'id') : [],
          shippers: this.priceData.shippers ? getArrayByProperty(this.priceData.shippers, 'id') : [],
          delivery_method: this.priceData.delivery_method?.id,
          profiles: this.priceData.profiles ? getArrayByProperty(this.priceData.profiles, 'id') : [],
        };
        if (this.checkTWL()) {
          if (this.isNewPrice) {
            this.$http.post(`purchase/prices/`, {...saveData, status: 'active'})
              .then(handlerResponse).then((response) => {
              this.$notify(setNotifyData('Success', 'Price has been created!', 'success'));
              this.$store.dispatch('lots/loadPrices', {price_list_id: saveData.price_list});
              this.$root.$emit('updatePurchasePriceInfo', {id: saveData.price_list});
              this.handleSaveEvent(event)
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            })
          } else {
            this.$http.put(`purchase/prices/${this.priceData.id}/`, saveData).then(handlerResponse).then(() => {
              this.$notify(setNotifyData('Success', 'Price has been edited!', 'success'));
              this.$store.dispatch('lots/loadPrices', {price_list_id: saveData.price_list});
              this.$root.$emit('updatePurchasePriceInfo', {id: saveData.price_list});
              this.handleSaveEvent(event)
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            });
          }
        }
      },
      getSum() {
        if (this.priceData.price_per_unit && this.priceData.amount) {
          this.priceData.sum = (this.priceData.price_per_unit * this.priceData.amount).toFixed(2);
        } else {
          this.priceData.sum = ''
        }
      },
      selectHumidity(event) {
        this.humidity = event.humidity_list;
      },
      checkTWL() {
        if (Number(this.priceData.thickness_nominal_from) > Number(this.priceData.thickness_nominal_to)) {
          this.$notify(setNotifyData('', 'Minimum thickness could not be greater then maximum', 'error'));
          return false
        } else if (Number(this.priceData.width_nominal_from) > Number(this.priceData.width_nominal_to)) {
          this.$notify(setNotifyData('', 'Minimum width could not be greater then maximum', 'error'));
          return false
        } else if (Number(this.priceData.length_nominal_from) > Number(this.priceData.length_nominal_to)) {
          this.$notify(setNotifyData('', 'Minimum length could not be greater then maximum', 'error'));
          return false
        } else {
          return true
        }
      }
    },
    async beforeMount() {
      await this.loadSettings();
      this.setDefaults();
    },
    mounted() {
      this.$root.$on('openCreatePriceModal', async (selectedPrice) => {
        await this.$store.dispatch('woodware/getProfiles')
        if (this.$refs['createPriceModal']) {
          this.priceData = {...selectedPrice};
          if (selectedPrice.isNewPrice) {
            this.setDefaults();
          }
          this.priceDataInitial = {
            ...this.priceDataInitial,
            currency: selectedPrice.currency,
            isNewPrice: selectedPrice.isNewPrice
          };
          this.getSum();
          this.$refs['createPriceModal'].show();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openCreatePriceModal');
    },
    computed: {
      ...mapState('woodware', ['wood', 'profiles', 'humidity_list', 'delivery_methods', 'qualities_list']),
      ...mapState('partners', ['suppliers']),
      ...mapState('generic', ['incoterms']),
      isPriceListCompleted () {
        return this.priceList.status === 'completed'
      },
      isNewPrice () {
        return this.priceDataInitial.isNewPrice
      },
      isActivePrice() {
        return this.priceData.status === 'active' || this.isNewPrice
      },
      shouldDisableInput () {
        return !this.isActivePrice || this.isPriceListCompleted
      },
      title() {
        return this.isNewPrice
            ? `${this.$i18n.t('modal_dialogs.purchase_price.add_price')}`
            : `${this.$i18n.t('modal_dialogs.purchase_price.edit_price')}`
      }
    },
    watch: {
      'priceData.amount'() {
        this.getSum();
      },
      'priceData.price_per_unit'() {
        this.getSum();
      }
    }
  }
</script>

<style scoped lang="sass">
.sizes-label
  font-weight: 700
  color: #666
  font-size: 13px
.sizes-from-to
  display: flex
  align-items: center
  justify-content: space-between
  input
    max-width: 45%
</style>


// WEBPACK FOOTER //
// src/components/modals/PurchaseCreatePriceModal.vue